import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import FaultsApp from "../../faults-app/FaultsApp";
import faultsCss from "../../faults-app/faults.compiled.css?raw";

export default function FaultsPage() {
  const hostRef = useRef<HTMLDivElement>(null);
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);

  useEffect(() => {
    if (!hostRef.current) return;

    const root =
      hostRef.current.shadowRoot ??
      hostRef.current.attachShadow({ mode: "open" });

    setShadowRoot(root);
  }, []);

  return (
    <div
      ref={hostRef}
      dir="rtl"
      style={{
        display: "block",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      {shadowRoot &&
        createPortal(
          <>
            <style>{faultsCss}</style>
            <FaultsApp />
          </>,
          shadowRoot,
        )}
    </div>
  );
}
